import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';


//列表
export async function pzsupplierList(params) {
    return post(erpserver+'/pzsupplier/pzsupplierList', params, true);
}
//详情
export async function pzsupplierDetail(params) {
    return post(erpserver+'/pzsupplier/pzsupplierDetail', params, true);
}
//新增、编辑
export async function savePzsupplier(params) {
    return post(erpserver+'/pzsupplier/savePzsupplier', params, true);
}
//删除
export async function deletePzsupplier(params) {
    return post(erpserver+'/pzsupplier/deletePzsupplier', params, true);
}
// 归属组
export async function selectGsz(params) {
    return post(erpserver+'/assay/selectGsz', params, true);
}
